module.exports = require("rxjs/observable/ErrorObservable");


//////////////////
// WEBPACK FOOTER
// external "rxjs/observable/ErrorObservable"
// module id = 247
// module chunks = 0